import { useId, type ReactNode } from "react";
import { cx } from "../../lib/cx.js";

/**
 * Globo de ayuda que aparece con el mouse Y con el foco del teclado (el atributo
 * title no se ve al tabular ni en pantallas táctiles). El texto también queda
 * enlazado por aria-describedby para lectores de pantalla.
 */
export function Tooltip({
  content, children, className, side = "top", align = "center",
}: {
  content: ReactNode;
  children: ReactNode;
  className?: string;
  side?: "top" | "bottom";
  /** "end" para disparadores pegados al borde derecho (el globo crece hacia la izquierda). */
  align?: "center" | "end";
}) {
  const id = useId();
  return (
    <span className={cx("group/tt relative inline-flex", className)}>
      <span tabIndex={0} aria-describedby={id} className="inline-flex rounded-md">
        {children}
      </span>
      <span
        role="tooltip"
        id={id}
        className={cx(
          // display:none mientras está oculto: un globo invisible igual ensancharía la página en móvil.
          "pointer-events-none absolute z-40 hidden w-max max-w-[min(16rem,calc(100vw-2rem))] rounded-md bg-fg px-2 py-1",
          "text-[12px] leading-snug font-normal whitespace-normal text-bg shadow-pop",
          "group-hover/tt:block group-focus-within/tt:block",
          align === "center" ? "left-1/2 -translate-x-1/2" : "right-0",
          side === "top" ? "bottom-full mb-1.5" : "top-full mt-1.5",
        )}
      >
        {content}
      </span>
    </span>
  );
}
